import { render, staticRenderFns } from "./ChatImageMessage.vue?vue&type=template&id=b7daccca&scoped=true&lang=pug&"
import script from "./ChatImageMessage.vue?vue&type=script&lang=js&"
export * from "./ChatImageMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatImageMessage.vue?vue&type=style&index=0&id=b7daccca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7daccca",
  null
  
)

export default component.exports